import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useBooking } from "@/context/BookingContext";
import { ButterflyIcon } from "./ButterflyIcon";

export const Header = () => {
  const { T, lang, setLang } = useLanguage();
  const { openBooking } = useBooking();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { to: "/", label: T.nav.home },
    { to: "/sobre", label: T.nav.about },
    { to: "/tratamentos", label: T.nav.treatments },
    { to: "/resultados", label: T.nav.results },
    { to: "/precos", label: T.nav.pricing },
    { to: "/contato", label: T.nav.contact },
    { to: "/blog", label: T.nav.blog },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-[#F7F0E8]/95 backdrop-blur-md border-b border-[#090708]/8" data-testid="site-header">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-16 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          <ButterflyIcon className="w-9" />
          <div>
            <p className="text-base uppercase tracking-[0.3em] font-normal text-[#9B6179] leading-tight">Studio Carolina Aguiar</p>
            <p className="text-[9px] uppercase tracking-[0.2em] text-[#090708]/40 leading-tight">{T.nav.tagline}</p>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `text-[11px] tracking-[0.15em] uppercase transition-colors hover:text-[#9B6179] ${isActive ? "text-[#090708] border-b border-[#E8C47A]" : "text-[#090708]/60"} pb-1`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-6">
          <div className="flex items-center gap-1.5 text-[11px] tracking-widest" data-testid="lang-switch">
            <button onClick={() => setLang("pt")} data-testid="lang-btn-pt" className={lang === "pt" ? "text-[#090708] font-semibold" : "text-[#090708]/40"}>PT</button>
            <span className="text-[#090708]/20">/</span>
            <button onClick={() => setLang("fr")} data-testid="lang-btn-fr" className={lang === "fr" ? "text-[#090708] font-semibold" : "text-[#090708]/40"}>FR</button>
          </div>
          <button
            onClick={() => openBooking()}
            data-testid="header-book-button"
            className="rounded-[2px] bg-[#090708] text-[#F7F0E8] px-6 py-3 text-[11px] tracking-[0.2em] uppercase hover:bg-[#6F3F55] transition-colors duration-300 border border-[#E8C47A]/30"
          >
            {T.nav.book}
          </button>
        </div>

        <button className="lg:hidden text-[#090708]" onClick={() => setMenuOpen(!menuOpen)} data-testid="mobile-menu-toggle">
          {menuOpen ? <X /> : <Menu />}
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-[#F7F0E8] border-t border-[#090708]/8 px-6 py-6 space-y-4" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setMenuOpen(false)} className="block text-xs tracking-widest uppercase text-[#090708]/70 py-1">
              {l.label}
            </NavLink>
          ))}
          <div className="flex items-center gap-2 pt-2 text-xs tracking-widest">
            <button onClick={() => setLang("pt")} className={lang === "pt" ? "text-[#090708] font-semibold" : "text-[#090708]/40"}>PT</button>
            <span className="text-[#090708]/20">/</span>
            <button onClick={() => setLang("fr")} className={lang === "fr" ? "text-[#090708] font-semibold" : "text-[#090708]/40"}>FR</button>
          </div>
          <button onClick={() => { openBooking(); setMenuOpen(false); }} className="rounded-[2px] w-full bg-[#090708] text-[#F7F0E8] py-3 text-[11px] tracking-[0.2em] uppercase">
            {T.nav.book}
          </button>
        </div>
      )}
    </header>
  );
};
